export enum NAVBoolean {
  unknown = "unknown",
  true = "true",
  false = "false",
}

export enum SuccessStatus {
  passed = "passed",
  failed = "failed",
  unknown = "unknown",
}

export enum CompletionStatus {
  completed = "completed",
  incomplete = "incomplete",
  unknown = "unknown",
}

export enum LogLevelEnum {
  _,
  DEBUG,
  INFO,
  WARN,
  ERROR,
  NONE,
}
